import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ActionButtonSize, ActionButtonType } from "./action-button.model";

@Component({
  selector: "app-action-button",
  templateUrl: "./action-button.component.html",
  styleUrls: ["./action-button.component.scss"],
  imports: [CommonModule],
  standalone: true,
})
export class ActionButtonComponent {
  @Input() disabled: boolean = false;
  @Input() buttonType: ActionButtonType = ActionButtonType.Primary;
  @Input() buttonSize: ActionButtonSize = ActionButtonSize.Normal;

  @Output() clicked = new EventEmitter<void>();

  getButtonType() {
    const buttonClass = "action-button__";
    switch (this.buttonType) {
      case ActionButtonType.Primary:
        return `${buttonClass}primary-button`;
      case ActionButtonType.Confirm:
        return `${buttonClass}confirm-button`;
      case ActionButtonType.Cancel:
        return `${buttonClass}cancel-button`;
      default:
        return `${buttonClass}primary-button`;
    }
  }

  getButtonSize() {
    const buttonClass = "action-button--";

    switch (this.buttonSize) {
      case ActionButtonSize.Normal:
        return `${buttonClass}normal`;
      case ActionButtonSize.Small:
        return `${buttonClass}small`;
      case ActionButtonSize.Smaller:
        return `${buttonClass}smaller`;
      default:
        return `${buttonClass}normal`;
    }
  }

  onClick() {
    this.clicked.emit();
  }
}
